<div class="label_properties">
    <small class="debug">{{ me }}</small>

    <!--     Multi-label selection mode - show ONLY this when hasSelectedLabels is true -->
    @if (hasSelectedLabels) {
        <div>
            <mat-label>{{'general.multiLabel' | transloco}}</mat-label>
            <br/>
            <app-font-selector #fontLoader
                               (onChange)="onMultiFonChanged($event, '', 'Label')"
                               [setConfig]="{i_config: sceneItem}"
                               [staleMode]="true"></app-font-selector>
        </div>
    } @else {
        <!-- Regular UI - show only when hasSelectedLabels is false -->
        @if (isNestedScene) {
            <div>
          <span style="position: relative; top: -8px; left: 5px">
            <button color="warn" mat-flat-button (click)="linkToNestedScene()">
              <mat-icon>link</mat-icon>
                {{ 'general.jumpToScene' | transloco }}
            </button>
              <!--            <button mat-raised-button (click)="linkToNestedScene()">-->
              <!--                <mat-icon>link</mat-icon>-->
              <!--                {{'general.jumpToScene' | transloco}}-->
              <!--            </button>-->
        </span>
                <br />
                <br />
                <span>
          name: {{ nestedSceneLabel }}
        </span>
                <br />
            </div>
        }

        @if (mimeType && experienceLevel > experienceLevelType.BEGINNER) {
            @if (!isSceneTopPropsMode) {
                <br />
                <div>
                    <mat-label class="sceneTypeLabel">{{ 'general.sceneType' | transloco }}: {{ mimeType }}</mat-label>
                    <br />
                    <br />
                </div>
            }
        }
        @if (!isNestedScene) {
            <div>
                @if (dynamicsInitialized) {
                    <div>
                        <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
                        </dynamic-form>
                    </div>
                }
            </div>
        }
        @if (isMimeMainPlayer && !isSceneTopPropsMode && !isNestedScene && experienceLevel > experienceLevelType.BEGINNER) {
            <div>
                <fa-icon size="lg" [icon]="faPlugCircleCheck"></fa-icon>
                <mat-checkbox (change)="togglePlayerAssignable($event)"
                              [checked]="isPlayerAssignable">{{ 'general.playerAssignable' | transloco }}
                </mat-checkbox>
            </div>
        }
        <br />
        @if (mimeType && !isMimeMainPlayer) {
            <div>
                <button mat-raised-button (click)="convertAssignable()">
                    <fa-icon size="sm" class="status-icon assignedIcons" [icon]="faPlugCircleCheck"></fa-icon>
                    {{ 'general.convertAssignable' | transloco }}
                </button>
            </div>
        }
        <br />
        <br />
        <br />
    }
    <br />
    <br />
    <br />
    <br />
</div>

